// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__2zNLt","radioRow":"SimpleQuestionBuilderModal_radioRow__2xQGy"};